/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { useContext, useMemo } from 'react';

import { DatasetImport } from '../../../../../../../../types/dataset/DatasetImport';
import { DatasetImportsTableContext } from '../../DatasetImportsTable.context';
import { DatasetImportsTableImportRow } from '../DatasetImportsTableImportRow/DatasetImportsTableImportRow';
import { DatasetImportsTableOperationHeading } from '../DatasetImportsTableOperationHeading/DatasetImportsTableOperationHeading';
import { DatasetImportsTableOperationRow } from '../DatasetImportsTableOperationRow/DatasetImportsTableOperationRow';

type DatasetImportsTableImportProps = {
  databaseName: string;
  datasetImport: DatasetImport;
};

export function DatasetImportsTableImport(props: DatasetImportsTableImportProps) {
  const { databaseName, datasetImport } = props;

  const { isCollapsedSchema } = useContext(DatasetImportsTableContext);

  const isCollapsed = useMemo(
    () => isCollapsedSchema(datasetImport.dataset.schema, databaseName),
    [databaseName, datasetImport.dataset.schema, isCollapsedSchema],
  );

  return (
    <>
      <DatasetImportsTableImportRow datasetImport={datasetImport} databaseName={databaseName} />

      {!isCollapsed && (
        <>
          <DatasetImportsTableOperationHeading />
          {datasetImport.operations.map(datasetImportOperation => (
            <DatasetImportsTableOperationRow key={datasetImportOperation.id} operation={datasetImportOperation} />
          ))}
        </>
      )}
    </>
  );
}
